import React, { useState } from "react";
import About from "./Aboutus";
import Home from './Homes';
import Service from './Service';
import Store from "../store/Store";
import './App.css';
import Account from './Account';
import './Navbar.css';
import Cart from "../store/pages/Cart";
import Login from "../store/pages/Login";
import Register from "../store/pages/Register";
import AccidentalService from "./AccidentalService";
import Contact from "./Contact";
import StoreNavBar from "../store/Components/StoreNavbar";
import Announcement from "../store/Components/Announcement";
import Regularservice from "./Regularservice";
import "./style/navbar.css"

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  NavLink
} from "react-router-dom";
import { useSelector } from "react-redux";
import ServiceForm from "./Emergency";
import Carwash from "./Carwash";

const NavBar = () => {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  // const user=false;
  console.log(isNavExpanded)
  // // const user =useSelector((state)=>state.user.currentUser);
  const user = localStorage.getItem("persist:root") ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user).currentUser === null ?
    false : true : "";
  //console.log(JSON.parse(JSON.parse(localStorage.getItem("persist:root")).user).currentUser);
  return (
    <Router>
      {/* <Announcement></Announcement> */}
      {/* <StoreNavBar></StoreNavBar> */}
      <nav className="navigation1">
        <a href="/" className="brand-name">
          <img src="/images/logomech.png" alt="mechon" />
        </a>
        <button className="hamburger" onClick={() => {
          setIsNavExpanded(!isNavExpanded);
        }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="white"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
          className={
            isNavExpanded ? "navigation-menu expanded" : "navigation-menu"
          }>
          <ul>
            <li>
              <NavLink onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }} exact to="/" activeClassName="menu_Link">Home</NavLink>
            </li>
            <li>
              <NavLink onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }} exact to="/service" activeClassName="menu_Link">Services</NavLink>
            </li>
            <li>
              <NavLink onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }} exact to="/store" activeClassName="menu_Link">Store</NavLink>
            </li>
            <li>
              <NavLink onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }} exact to="/about" activeClassName="menu_Link">About Us</NavLink>
            </li>
            <li>
              <NavLink onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }} to="/contact" activeClassName="menu_Link">Contact</NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <Switch>
        <Route exact path="/"><Home /></Route>
        <Route exact path="/about"> <About /> </Route>
        <Route exact path="/service"> <Service /> </Route>
        <Route exact path="/store"> <Store /> </Route>
        <Route exact path="/contact"><Contact /></Route>
        <Route exact path="/service/reqService"><ServiceForm /></Route>
        <Route exact path="/store/products/:category"><Store /> </Route>
        <Route exact path="/store/product/:id"><Store /></Route>
        <Route exact path="/store/success"><Store /></Route>
        <Route exact path="/register">
          <Register />
        </Route>
        <Route exact path="/cart"> <Cart /></Route>
        <Route exact path="/login">
          {!user ? <Login /> : <Redirect to="/" />}
        </Route>
      </Switch>
    </Router>


  );
}
export default NavBar;